import React, { useEffect, useState } from 'react';
import { Grid, Paper, LinearProgress } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { useTheme } from '@mui/material/styles';
import SideBar from './sideBar';
import LineChartToggle from './lineChartToggle';
import Rightbar from './rightbar';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import UpdateIcon from '@mui/icons-material/Update';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import NoDataImg from '../../../assets/images/No_data-amico.svg';
import { useSelector } from 'react-redux';
import dummydata from './data.json';
// import { getUniqueWalkinWalkout } from 'api'; // keep only this one
import { SkeletonLoader } from '../../../component/SkeletonLoader';

const StorePage = () => {
  const theme = useTheme();
  const date = useSelector((state) => state.customization.currentDate);

  const [storeName, setStoreName] = useState('');
  const [footfalldata, setFootfalldata] = useState(0); // total/store footfall
  const [ftfall, setftfall] = useState([]); // zone footfall
  const [ setEmpZoneCounts] = useState([]);
  const [isFootfallLoading, setIsFootfallLoading] = useState(true);
  const [departments, setDepartments] = useState([]);

  const selectedTime = useSelector((state) => state.customization.selectedTime);
  const startTime = selectedTime?.start_time ? new Date(selectedTime.start_time) : new Date();
  const endTime = selectedTime?.end_time ? new Date(selectedTime.end_time) : new Date();
  const start_time = startTime.toUTCString();
  const end_time = endTime.toUTCString();

  const source = localStorage.getItem('source');

  // Store name
  useEffect(() => {
    const storedName = localStorage.getItem('storeName');
    setStoreName(storedName || 'ISKCON');
  }, []);

  // Departments (for zone colors)
  async function getDepartments(signal) {
    try {
      const response = await fetch('https://neoe2e.neophyte.live/iskcon-api/api/sentinel/getAllCameras', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ source_id: 'bealpur-001' }),
        signal
      });
      const data = await response.json();
      if (!signal.aborted && data.status === 200) {
        setDepartments(Array.isArray(data.data) ? data.data : []);
      }
    } catch (error) {
      if (!signal.aborted) console.error('Error fetching departments:', error);
    }
  }

  const hardcodedFootfallData = {
  "2025-08-15": {
    store_footfall: 21908,
    zoneFootfall: [
      { zone_name: "Camera-001", footfall: 16332, attended: 0 },
      { zone_name: "Camera-002", footfall: 2333, attended: 0 },
      { zone_name: "Camera-003", footfall: 1623, attended: 0 },
      { zone_name: "Camera-004", footfall: 729, attended: 0 },
      { zone_name: "Camera-005", footfall: 869, attended: 0 }
    ]
  },
  "2025-08-16": {
    store_footfall: 39667,
    zoneFootfall: [
      { zone_name: "Camera-001", footfall: 18029, attended: 0 },
      { zone_name: "Camera-002", footfall: 4573, attended: 0 },
      { zone_name: "Camera-003", footfall: 3831, attended: 0 },
      { zone_name: "Camera-004", footfall: 10074, attended: 0 },
      { zone_name: "Camera-005", footfall: 3149, attended: 0 }
    ]
  }
};

  // Dummy zone counts (unchanged logic)
  async function getEmpZonewiseCount(_commonBody, signal) {
    try {
      const data = dummydata.zoneEmployeeCount;
      if (!signal.aborted) {
        setEmpZoneCounts(Array.isArray(data) ? data : []);
      }
    } catch (error) {
      if (!signal.aborted) {
        setEmpZoneCounts([]);
        console.log(error);
      }
    }
  }

  // Single fetch of unique walk-in/walkout (no polling)
  // async function fetchFootfall(formattedDate, signal) {
  //   setIsFootfallLoading(true);
  //   try {
  //     const requestData = { date: formattedDate, source_id: source, start_time, end_time };
  //     const response = await getUniqueWalkinWalkout(requestData, { signal });
  //     const data = response?.data?.data?.[0]?.footfall;

  //     if (!signal.aborted) {
  //       if (!data || !Array.isArray(data.zoneFootfall) || data.zoneFootfall.length === 0) {
  //         setFootfalldata(0);
  //         setftfall([]);
  //       } else {
  //         setFootfalldata(Number(data.store_footfall) || 0);
  //         setftfall([...data.zoneFootfall]); // new reference to ensure re-render
  //       }
  //     }
  //   } catch (error) {
  //     if (!signal.aborted) {
  //       console.log('getUniqueWalkinWalkout error:', error);
  //       setFootfalldata(0);
  //       setftfall([]);
  //     }
  //   } finally {
  //     if (!signal.aborted) setIsFootfallLoading(false);
  //   }
  // }


  async function fetchFootfall(formattedDate, signal) {
  setIsFootfallLoading(true);
  try {
    if (!signal.aborted) {
      const data = hardcodedFootfallData[formattedDate];

      if (!data || !Array.isArray(data.zoneFootfall) || data.zoneFootfall.length === 0) {
        setFootfalldata(0);
        setftfall([]);
      } else {
        setFootfalldata(Number(data.store_footfall) || 0);
        setftfall([...data.zoneFootfall]); // ensure re-render
      }
    }
  } catch (error) {
    if (!signal.aborted) {
      console.log("Hardcoded fetchFootfall error:", error);
      setFootfalldata(0);
      setftfall([]);
    }
  } finally {
    if (!signal.aborted) setIsFootfallLoading(false);
  }
}


  // Fetch data once per dependency change (no repeated intervals)
  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal;

    const formatDate = (dateString) => new Date(dateString).toISOString().split('T')[0];
    const formattedDate = formatDate(date);

    // call everything once
    fetchFootfall(formattedDate, signal);
    getEmpZonewiseCount({ start_date: date }, signal);
    getDepartments(signal);

    return () => {
      abortController.abort();
    };
  }, [date, selectedTime, start_time, end_time, source]);

  const mainContentStyle = {
    maxWidth: '100%',
    minWidth: '0',
    height: '100%',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    [theme.breakpoints.down('md')]: { marginLeft: 0, width: '100%' }
  };

  const paperStyle = {
    width: '100%',
    maxHeight: '280px',
    height: '280px',
    padding: '10px',
    marginBottom: '20px',
    position: 'relative',
    left: 'auto',
    borderRadius: '15px',
    display: 'flex',
    alignItems: 'center',
    flex: '1'
  };

  const disabledPaperStyle = {
    ...paperStyle,
    opacity: 0.5,
    filter: 'grayscale(50%)',
    backgroundColor: '#f5f5f5',
    border: '2px dashed #ccc',
    cursor: 'not-allowed',
    position: 'relative'
  };

  // Prepare a sorted copy for rendering (no state mutation during render)
  const sortedFtfall = Array.isArray(ftfall)
    ? [...ftfall].sort((a, b) => a.footfall - b.footfall)
    : [];

  const DisabledOverlay = ({ title }) => (
    <div className="absolute inset-0 bg-white bg-opacity-80 flex items-center justify-center z-10 rounded-[15px]">
      <div className="text-center">
        <LockIcon sx={{ fontSize: 40, color: '#999', mb: 1 }} />
        <p className="text-gray-600 font-medium text-sm">{title}</p>
      </div>
    </div>
  );

  return (
    <Grid container spacing={1}>
      <SideBar selField="storeOverview" />
      <Grid item md={12} sx={mainContentStyle}>
        <div className="flex items-center mb-5 -mt-10 pl-2">
          <h1 className="text-2xl font-bold text-gray-800">{storeName}</h1>
        </div>

        <Grid container spacing={1}>
          {/* Footfall Trend Card - ACTIVE */}
          <Grid item xs={12} md={3} sm={6} sx={{ width: '100%', mb: -1, mt: 1, [theme.breakpoints.up('md')]: { mt: -1 } }}>
            <Paper elevation={3} sx={paperStyle}>
              {isFootfallLoading ? (
                <SkeletonLoader />
              ) : sortedFtfall.length > 0 ? (
                <div className="flex w-full flex-col gap-1">
                  <div className="flex items-center justify-center gap-2 w-full">
                    <DirectionsWalkIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                    <div className="w-full">
                      <div className="flex items-center gap-2">
                        <div className="flex items-center gap-1">
                          <p className="text-3xl">{Math.round(footfalldata) || 0}</p>
                          <p className="text-sm text-gray-600 mt-1">Devotee</p>
                        </div>
                      </div>
                      <p className="text-lg mt-1">Footfall Trend</p>
                    </div>
                  </div>
                  <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                    {(() => {
                      const maxFootfall = Math.max(...sortedFtfall.map((item) => item.footfall), 1);
                      return sortedFtfall.map((item, index) => {
                        const percentage = (item.footfall / maxFootfall) * 100;
                        const barcolor = percentage >= 80 ? '#44BE54' : percentage >= 50 ? '#ffbf00' : '#ff413a';

                        const department = Array.isArray(departments)
                          ? departments.find((dept) => dept.name === item.zone_name)
                          : null;
                        const zoneColor = department ? department.color : '#2D9BBC';

                        return (
                          <div className="mt-2" key={`${item.zone_name}-${index}`}>
                            <div className="flex gap-1 items-center">
                              <div className="rounded-full h-4 w-4" style={{ backgroundColor: zoneColor }}></div>
                              <div>
                                {item.zone_name} : {item.footfall}
                              </div>
                            </div>
                            <LinearProgress
                              variant="determinate"
                              value={percentage}
                              sx={{
                                marginTop: '5px',
                                backgroundColor: '#c8c8c8',
                                '& .MuiLinearProgress-bar': { backgroundColor: `${barcolor}` }
                              }}
                            />
                          </div>
                        );
                      });
                    })()}
                  </div>
                </div>
              ) : (
                <img className="w-80 h-80 ml-10 mb-10" src={NoDataImg} alt="No data" />
              )}
            </Paper>
          </Grid>

          {/* Avg Dwell Time Card - DISABLED */}
          <Grid item xs={12} md={3} sm={6} sx={{ width: '100%', mb: -1, mt: 1, [theme.breakpoints.up('md')]: { mt: -1 } }}>
            <Paper elevation={1} sx={disabledPaperStyle}>
              <DisabledOverlay title="Not Available" />
              <div className="flex flex-col w-full gap-1 opacity-30">
                <div className="flex items-center justify-center gap-2 w-full">
                  <UpdateIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                  <div className="w-full">
                    <p className="text-3xl">--</p>
                    <p className="text-lg">Avg Dwell Time</p>
                  </div>
                </div>
                <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] scrollbar rounded-lg p-2.5">
                  <div className="text-center text-gray-400 mt-16">Data Not Available</div>
                </div>
              </div>
            </Paper>
          </Grid>

          {/* Avg Emp. Availability Card - DISABLED */}
          <Grid item md={3} sm={6} sx={{ width: '100%', mb: -1, mt: 1, [theme.breakpoints.up('md')]: { mt: -1 } }}>
            <Paper elevation={1} sx={disabledPaperStyle}>
              <DisabledOverlay title="Not Available" />
              <div className="flex w-full flex-col gap-1 opacity-30">
                <div className="flex items-center justify-center gap-2 w-full">
                  <EmojiPeopleIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                  <div className="w-full">
                    <div className="flex items-baseline gap-2">
                      <p className="text-3xl">--%</p>
                    </div>
                    <p><span className="text-lg">Avg Emp. Availability</span></p>
                  </div>
                </div>
                <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                  <div className="text-center text-gray-400 mt-16">Data Not Available</div>
                </div>
              </div>
            </Paper>
          </Grid>

          {/* Employee : Customer Card - DISABLED PLACEHOLDER */}
          <Grid item md={3} sm={6} sx={{ width: '100%', mb: -1, mt: 1, [theme.breakpoints.up('md')]: { mt: -1 } }}>
            <Paper elevation={1} sx={disabledPaperStyle}>
              <DisabledOverlay title="Not Available" />
              <div className="flex w-full flex-col gap-2 opacity-30">
                <div className="flex items-center justify-center gap-2 w-full">
                  <EmojiPeopleIcon className="bg-[#444444] text-white rounded-full p-2 text-5xl" />
                  <div className="w-full">
                    <div className="flex items-baseline gap-2">
                      <p className="text-3xl">--%</p>
                    </div>
                    <p><span className="text-lg">Avg Emp. Availability</span></p>
                  </div>
                </div>
                <div className="bg-slate-100 flex-grow overflow-y-auto h-[184px] p-2 rounded-lg scrollbar">
                  <div className="text-center text-gray-400 mt-16">Data Not Available</div>
                </div>
              </div>
            </Paper>
          </Grid>
        </Grid>

        <Grid container spacing={1}>
          <Grid item md={9} sm={12}><LineChartToggle /></Grid>
          <Grid item md={3} sm={12}><Rightbar /></Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default StorePage;
